<template>
    <!-- 轮播图 -->
    <div :class="swiperName">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in slideArray" :key="index" v-show="slideArray.length !== 0">
                <img :src="item.url" class="imgStyle" />
            </div>
            <slot name="swiper"></slot>
        </div>
        <!-- 如果需要分页器 -->
        <div v-if="setting.usePagination || true" class="swiper-pagination"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            setting: {}
        };
    },
    props: {
        slideArray: {
            type: Array,
            default: () => [
                { url: require("@/assets/bigImg.png") },
            ]
        },
        swiperSetting: {
            type: Object
        },
        swiperName: {
            type: String,
            default: "swiper-container"
        }
    },
    mounted() {
        this.setting = this.swiperSetting ? this.swiperSetting : {};
        console.log(this.setting)
    },
    updated() {
        new Swiper("." + this.swiperName, {
            // 方向
            direction: this.setting.direction || "horizontal",
            //分页器
            pagination: ".swiper-pagination",
            //循环
            loop: this.setting.loop || true,
            //分页器点击
            paginationClickable: true,
            //时长
            autoplay: this.setting.delay || 3000,
            //点击不会取消自动
            autoplayDisableOnInteraction: false,
            // 手掌
            grabCursor: true,
            // // 特效
            effect: this.setting.effect || "slide",
        });
    },

};
</script>

<style scoped>
.swiper-container {
    height: 100%;
    width: 100%;
}

.swiper-wrapper {
    margin: 0;
    padding: 0;
}

.swiper-slide {
    margin: 0;
    padding: 0;
}

.imgStyle {
    height: 100%;
    width: 100%;
}


/deep/ .swiper-pagination {
    margin-right: 2%;
}

/deep/ .swiper-pagination-bullet {
    background-color: #fff;
    opacity: 1;
}

/deep/ .swiper-pagination-bullet-active {
    background-color: #8a0000;
}

.swiper-container-vertical>.swiper-pagination-bullets /deep/ .swiper-pagination-bullet {
    margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/assembly/mobileSwiper.vue